/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterExtendedRuntimeEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_EXTENDED_RUNTIME_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierStarterExtendedRuntimeEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterExtendedRuntimeEnabledSettingParser.decode(input).map(res => new TierStarterExtendedRuntimeEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterExtendedRuntimeEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterExtendedRuntimeEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierStarterExtendedRuntimeEnabledSettingParser.schema();
    }
}
